import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "feedback-manager-container" }
const _hoisted_2 = { class: "feedback-header-panel" }
const _hoisted_3 = { class: "header-stats" }
const _hoisted_4 = { class: "stat-pill" }
const _hoisted_5 = { class: "feedback-main-card" }
const _hoisted_6 = { class: "id-tag" }
const _hoisted_7 = { class: "title-txt" }
const _hoisted_8 = { class: "desc-txt" }
const _hoisted_9 = { class: "contact-cell" }
const _hoisted_10 = {
  key: 0,
  class: "email"
}
const _hoisted_11 = {
  key: 1,
  class: "phone"
}
const _hoisted_12 = {
  key: 2,
  class: "empty-txt"
}
const _hoisted_13 = { class: "pagination-bar" }
const _hoisted_14 = { class: "dialog-body-wrap" }
const _hoisted_15 = { class: "feedback-meta-block" }
const _hoisted_16 = { class: "meta-row" }
const _hoisted_17 = { class: "meta-val font-bold" }
const _hoisted_18 = { class: "meta-row" }
const _hoisted_19 = { class: "meta-val highlight" }
const _hoisted_20 = {
  key: 0,
  class: "meta-row"
}
const _hoisted_21 = { class: "meta-val" }
const _hoisted_22 = { class: "meta-row" }
const _hoisted_23 = { class: "meta-val" }
const _hoisted_24 = { class: "user-content-box" }
const _hoisted_25 = { class: "user-desc-text" }
const _hoisted_26 = { class: "reply-input-section" }
const _hoisted_27 = { class: "reply-title-row" }
const _hoisted_28 = { class: "section-title" }
const _hoisted_29 = {
  key: 0,
  class: "reply-tip"
}
const _hoisted_30 = { class: "dialog-footer-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Iphone = _resolveComponent("Iphone")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header-left" }, [
        _createElementVNode("h2", { class: "module-title" }, "用户问卷与意见反馈管理"),
        _createElementVNode("span", { class: "module-desc" }, "查看玩家在游玩或研学过程中提交的建议、体验评价与异常反馈，支持邮件即时答复")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "反馈记录共 " + _toDisplayString(_ctx.total) + " 条", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.tableData,
        class: "custom-feedback-table",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "编号",
            prop: "feedbackId",
            width: "90",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_6, "#" + _toDisplayString(row.feedbackId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "反馈主题",
            prop: "feedbackTitle",
            "min-width": "150"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(row.feedbackTitle || "用户体验反馈"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "反馈详情",
            prop: "feedbackDesc",
            "min-width": "220",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(row.feedbackDesc || "无详细描述"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "联系方式",
            "min-width": "180"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_9, [
                (row.feedbackEmail)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Message)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(row.feedbackEmail), 1)
                    ]))
                  : _createCommentVNode("", true),
                (row.feedbackIphone || row.feedbackPhone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Iphone)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(row.feedbackIphone || row.feedbackPhone), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
                  !row.feedbackEmail &&
                  !row.feedbackIphone &&
                  !row.feedbackPhone
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "处理结果",
            prop: "feedbackResult",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", {
                class: _normalizeClass(row.feedbackResult ? 'result-txt' : 'empty-txt')
              }, _toDisplayString(row.feedbackResult || "暂未回复"), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            width: "110",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tag, {
                type: row.feedbackStatus == 0 ? 'warning' : 'success',
                effect: "light",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.feedbackStatus == 0 ? "待处理" : "已答复"), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "提交时间",
            prop: "createTime",
            width: "170",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "120",
            align: "right",
            fixed: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                type: row.feedbackStatus == 0 ? 'primary' : 'default',
                size: "small",
                class: "action-btn",
                onClick: ($event: any) => (_ctx.handleEdit(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.feedbackStatus == 0 ? "处理回复" : "查看详情"), 1)
                ]),
                _: 2
              }, 1032, ["type", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loadingTable]
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "total, prev, pager, next",
          "current-page": _ctx.currentPage,
          "page-size": 10,
          total: _ctx.total,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["current-page", "total", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.isReadonly ? '反馈详情与处理记录' : '处理用户反馈与答复',
      width: "640px",
      class: "custom-feedback-dialog",
      "destroy-on-close": "",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isReadonly ? "关闭" : "取消"), 1)
            ]),
            _: 1
          }),
          (!_ctx.isReadonly)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                class: "submit-reply-btn",
                loading: _ctx.submitting,
                onClick: _ctx.submitReply
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" 发送回复并归档 ", -1)
                ]))]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "meta-label" }, "反馈主题:", -1)),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.form.feedbackTitle || "无标题"), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "meta-label" }, "用户邮箱:", -1)),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.form.feedbackEmail || "未留下邮箱"), 1)
            ]),
            (_ctx.form.feedbackIphone || _ctx.form.feedbackPhone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "meta-label" }, "手机号码:", -1)),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.form.feedbackIphone || _ctx.form.feedbackPhone), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "meta-label" }, "提交时间:", -1)),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.form.createTime || "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "box-title" }, "用户原始反馈内容：", -1)),
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.form.feedbackDesc || "无详细描述内容"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "section-indicator" }, null, -1)),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.isReadonly ? "系统答复记录" : "编辑答复邮件内容"), 1)
            ]),
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.feedbackResult,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.feedbackResult) = $event)),
              rows: 5,
              type: "textarea",
              placeholder: 
              _ctx.isReadonly
                ? '暂无回复内容'
                : '请输入对用户的回复说明，提交后将自动发送邮件通知对方...'
            ,
              maxlength: "400",
              "show-word-limit": "",
              readonly: _ctx.isReadonly,
              class: "reply-textarea"
            }, null, 8, ["modelValue", "placeholder", "readonly"]),
            (!_ctx.isReadonly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                  _cache[10] || (_cache[10] = _createTextVNode(" * 提交后将直接调用邮件系统向 ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.form.feedbackEmail || "用户邮箱"), 1),
                  _cache[11] || (_cache[11] = _createTextVNode(" 发送本条答复。 ", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ]))
}